"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserTrackerEnum = void 0;
/**
 * Трекер активности пользователя
 */
var UserTrackerEnum;
(function (UserTrackerEnum) {
  /** Проведено занятий за последний месяц */
  UserTrackerEnum[UserTrackerEnum["monthly_meetings_provided"] = 1] = "monthly_meetings_provided";
  /** Опубликовано уроков за последний месяц */
  UserTrackerEnum[UserTrackerEnum["monthly_lessons_published"] = 2] = "monthly_lessons_published";
})(UserTrackerEnum = exports.UserTrackerEnum || (exports.UserTrackerEnum = {}));
